var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgOlxPay = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    fillRule: "evenodd",
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M64.704 8.467H31.296C27.82 8.467 25 11.43 25 15.088v66.276c0 3.657 2.82 6.62 6.296 6.62h33.408c3.477 0 6.296-2.963 6.296-6.62V15.087c0-3.657-2.82-6.621-6.296-6.621Z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: "var(--color-neutral-80)",
    d: "M26.006 13.006a4 4 0 0 1 4-4h35.988a4 4 0 0 1 4 4v31.938H26.006V13.006Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M64.704 8.467H31.296C27.82 8.467 25 11.43 25 15.088v66.276c0 3.657 2.82 6.62 6.296 6.62h33.408c3.477 0 6.296-2.963 6.296-6.62V15.087c0-3.657-2.82-6.621-6.296-6.621Z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M42.95 83.647h9.592"
  }), React.createElement("path", {
    fill: borderColor,
    d: "M52.456 8h-8.912a1.294 1.294 0 1 0 0 2.588h8.912a1.294 1.294 0 1 0 0-2.588Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M63.094 50.693h4.045M28.594 50.693h24.271M25 45.662h46"
  }), React.createElement("rect", {
    width: 38.813,
    height: 7.149,
    x: 28.594,
    y: 73.032,
    fill: color,
    rx: 3.574
  }), React.createElement("path", {
    fill: borderColor,
    d: "M34.562 67.237c2.128 0 3.812-1.804 3.812-4.245 0-2.409-1.6-4.23-3.812-4.23-2.12 0-3.812 1.805-3.812 4.246 0 2.449 1.6 4.229 3.812 4.229Zm0-1.82c-1.149 0-1.94-.975-1.94-2.41 0-1.449.791-2.424 1.94-2.424 1.15 0 1.941.975 1.941 2.409 0 1.45-.792 2.424-1.94 2.424ZM39.952 64.007h3.64c.25 0 .397-.153.397-.411v-1.192c0-.258-.148-.411-.396-.411h-2.438v-5.067c0-.258-.148-.41-.396-.41h-1.203c-.249 0-.396.152-.396.41v6.26c0 .53.28.82.792.82Z"
  }), React.createElement("path", {
    fill: borderColor,
    d: "m44.894 67.116 2.19-2.618 2.127 2.618c.187.234.42.234.637.04l.854-.781c.21-.193.24-.435.039-.66l-2.36-2.74 2.15-2.505c.186-.217.17-.45-.039-.66l-.807-.757c-.21-.202-.45-.194-.637.04l-1.964 2.368-2.003-2.368c-.187-.217-.42-.25-.637-.04l-.83.765c-.21.201-.226.427-.024.66l2.19 2.506-2.392 2.755c-.194.233-.17.467.039.66l.83.757c.218.194.459.177.637-.04ZM54.577 62.868c.186.203.474.317.745.317.49 0 .9-.415.9-.975 0-.44-.27-.756-.721-.756-.28 0-.544.13-.753.358l-.171 1.056Zm-1.304 2.698.815-4.852h.768l-.03.22a1.36 1.36 0 0 1 .853-.285c.746 0 1.382.61 1.382 1.52 0 .618-.31 1.268-.838 1.593-.24.146-.528.244-.846.244-.334 0-.653-.122-.948-.325l-.31 1.885h-.846ZM60.084 61.787a1.033 1.033 0 0 0-.745-.317c-.49 0-.9.415-.9.975 0 .44.271.756.721.756.28 0 .544-.13.754-.357l.17-1.057Zm1.033-1.073-.543 3.227h-.77l.032-.22a1.36 1.36 0 0 1-.854.285c-.745 0-1.382-.61-1.382-1.52 0-.618.31-1.268.838-1.593.241-.146.528-.244.847-.244.341 0 .683.122 1.009.374l.054-.309h.769ZM65.284 60.714l-2.973 4.852h-.955l1.203-1.95-.908-2.902h.862l.605 2 1.211-2h.956Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M60.636 31.839c-1.583-5.71-2.207-10.684-6.333-10.684H41.697c-4.126 0-4.75 4.975-6.333 10.684-1.351 4.873 2.163 6.302 4.183 4.743 1.39-1.072 3.31-5.082 3.31-5.082H53.143s1.92 4.01 3.309 5.082c2.02 1.56 5.534.13 4.183-4.743Z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M42.197 24.13v4.41M39.993 26.334h4.409"
  }), React.createElement("circle", {
    cx: 53.858,
    cy: 24.209,
    r: 0.719,
    fill: borderColor
  }), React.createElement("circle", {
    cx: 51.702,
    cy: 26.366,
    r: 0.719,
    fill: borderColor,
    transform: "rotate(-90 51.702 26.366)"
  }), React.createElement("circle", {
    cx: 53.858,
    cy: 28.522,
    r: 0.719,
    fill: borderColor
  }), React.createElement("circle", {
    cx: 56.014,
    cy: 26.366,
    r: 0.719,
    fill: borderColor,
    transform: "rotate(-90 56.014 26.366)"
  }));
};
export default SvgOlxPay;